import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}


function Companies(prop) {

    var global = window.GlobalVars;
    var tab;

	async function editCompany( company, add )
	{
		global.currentCompany = company;
		global.companyBackPage = 'companies';
		await window.saveSession();
		return window.goPage('companyedit', {company:company});



		var origCompany = clone(company);
		company.newname = company.name;
	    function cb(ev)
	    {
			frm.removeInlineErrors() // added 19/1 mani
			let err = false;
			if( !company.newname || !company.newname.trim() ) { 
				setTimeout( function(){frm.inlineError( $('#newname'), 'Company Name is required')}, 200 )
				err = true; 
			}
			if( !company.domain || !company.domain.trim() ) { 
				setTimeout( function(){frm.inlineError( $('#domain'), 'Company E-mail Domain is required')}, 200 )
				err = true; 
			}
			if( err ) {
				ev.preventDefault();
				ev.stopPropagation();
				return false;
			}
			var updateData = {
				_new: add || false,
				_id: company._id,
				name: company.newname,
				registername: company.registername,
				priv: company.priv,
				domain: company.domain,
				active: company.active ? true : false,
			};
			console.log( 'UPDATE_COMPANY', updateData );
	        window.post( 'update_company', {company:updateData}, function(res){
	            // console.log( 'UPDATE USER', res )
				if (res.data.status) {
					setTimeout(function () { document.location.reload(); }, 200);
				}
				else {
					// alert( res.data.value );
					frm.myAlert('Update Error', res.data.value);
				}
	        });
			return false;
	    }
		if( Date.now() > company.resetTimeout ) company.resetPassword = null;
		var content = `
		<div id="companydetails">
		<label for="name">Company Name</label>
		<input placeholder="Company Name" type="text" id="newname" class="mb-4 form-control">
		<input placeholder="Business Legal Name" type="text" id="registername" class="mb-4 form-control">
		<input placeholder="Company email Domain" type="text" id="domain" class="mb-4 form-control">
		<div id="companyActive"></div>
		<div id="companyPrivs"></div>
		</div>
		`;

		function changed()
		{
		}

		function close()
		{

		}
		var btnName = add ? 'Add Company' : 'Update Company';
		var title = add ? 'Add New Company' : 'Edit Company';
		frm.myAlert( title, content, btnName, cb, 'Cancel', close );

		setTimeout( function(){
			focus.focus();
		}, 500);

		['newname','registername','domain'].forEach( n =>
		{
			$('#companydetails').find('#'+n).val( company[n] ).on('change', function(){
				var id = $(this).prop('id');
				var val = $(this).val();
				console.log( 'change', id, val );
				company[id] = val;
				changed();
			})
		})
		var focus = $('#name');

		// frm.booleanList( $('#companyActive'), company)
		frm.booleanList( $('#companyActive'), company, {
			items: {
				'active': { default: false, label: 'Company Active' },
			},
			callbackOnInit: false,
		}, function(o){
			company.active = o.active;
			changed()
		});

		var companyPrivs = frm.arr2Bool(company.priv.split(','));
		var privItems = {};
		var allPrivs = clone(window.privs); delete allPrivs.admin;
		for( var p in allPrivs ) privItems[p] = { default: false, label: window.privs[p] };
		console.log( companyPrivs, privItems );
		frm.booleanList( $('#companyPrivs'), companyPrivs, {
			items: privItems,
			header: ['','Privileges'],
			callbackOnInit: false,
		}, function(o){
			var npriv = [];
			for( var p in o ) if(o[p]) npriv.push(p);
			company.priv = npriv.join(',');
			console.log( 'privs', o, company.priv );
			changed();
		} );
	    return false;
	}





    useEffect( function(a){
        $('#topbuttons').html('');

		var addCompanyBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary"><i class="fa fa-plus mr-2"></i>Add Company</Button>')
		addCompanyBut.on('click', () => {
			editCompany( 'new', 1 );
		})
		$('#topbuttons').append(addCompanyBut);
		var companySelect = window.GlobalVars.companyProjectSelect == 1;
		if( companySelect )
		{
			var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 ml-2 btn btn-secondary">Add Selected Companies to Project<span class="selcount"></span></Button>')
			$('#topbuttons').append(projBut);
			projBut.on('click', function(){
				if( Object.keys(window.GlobalVars.companyTableCtx.selected) == 0 )
				{
					// return frm.myAlert( '', 'Please select companies to be added to the project' );
				}
				else
					window.GlobalVars.companyProjectSelect = 2;
				window.saveSession();
				window.goPage('nlpWorkers');
			})
		}
		else {
			// window.GlobalVars.companyTableCtx = {};
		}


        var match = {active:true};
		window.post( 'find_companies', {match:match}, function(res){
			console.log( 'companies', res.data );
			var companies = res.data.records;
			if( !companies.length )
			{
				$('.alert').remove();
				var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No companies found');
				$('#topbuttons').prepend(empty);
				$('#documentlist').hide();
			}
            var desc = {
				selectMode: companySelect,
				selectId: 'email',
                title: 'ADL Company Management',
                columns: {
	                // _id: 'Id',
                    name: 'Name',
                    registername: 'Legal Name',
                    priv: 'Roles',
					domain: 'Email Domain',
					created: 'Created',
					active:'Active',
                },
                filter: true,
                search: true,
                sort: true,
                // sortAlias: { lastLoginDelta: 'lastLogin' },
                initialSort: 'lastLogin',
                initialSortDir: -1,
                pageSize: 10,
                // noFilter: ['lastLogin'],
                noSearch: null,
                noSort: null,
                centerCol: ['created','active'],
				format: tabler.formatString,
				formatCol: {
					lastLogin:tabler.formatTimeAgo,
					created:tabler.formatDate,
					priv:tabler.formatPriv,
					active: tabler.formatActive,
				},
				forceType:{ lastLogin: 1, active: 1, created: 1 },
				headerClick: 'filter',
                // clickCol: ['stateLabel','source'],
            }
            tab = tabler.table($('#documentlist'), desc, 'companies' );
            companies.forEach( a => {
                a.stateLabel = '<span class="state_'+a.state+'">' + a.stateLabel + '</span>';
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler click', a._id, row[col], row._id )
					editCompany( row._id );
                    // fileClickTabler( col, row )
                })
            });
            tab.draw();
			tab.saveCtx( selCount );
			selCount();
            console.log( 'desc', desc, 'tabler', tabler.formatString )
        });

    });

	function selCount()
	{
		var ctx = tabler.getCtx( 'companies' );
		var s = ctx.selected || {};
		$('.selcount').text(' ('+Object.keys(s).length+')')
	}

    return (
        <div fluid="md p-0" className="maincontent">
        <div id="topbuttons"></div>
        <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
        </Table>
        <span>&nbsp;</span>
        </div>
    )
}

export default Companies
